import { MODULE_ACTIONS, MODULES, type Action, type Module, type Permissions } from "./permissions";

const all: Permissions = Object.fromEntries(MODULES.map((m) => [m, [...MODULE_ACTIONS[m]]]));

const readOnly = (modules: readonly Module[]): Permissions =>
  Object.fromEntries(modules.map((m) => [m, ["read"] satisfies Action[]]));

export const DEFAULT_ROLES: { name: string; permissions: Permissions }[] = [
  { name: "Administrador", permissions: all },
  {
    name: "Vendedor",
    permissions: {
      contacts: ["read", "create", "update", "export"],
      products: ["read"],
      warehouses: ["read"],
      stock: ["read"],
      price_lists: ["read"],
      payment_terms: ["read"],
      sellers: ["read"],
      statuses: ["read"],
      quotes: ["read", "create", "update"],
      sales_orders: ["read", "create", "update"],
      service_orders: ["read", "create", "update"],
      pos: ["read", "create"],
      tax_operations: ["read"],
      invoices: ["read"],
      dashboard: ["read"],
      goals: ["read"],
      copilot: ["read"],
      custom_reports: ["read"],
      label_templates: ["read"],
      attachments: ["read", "create"],
      jobs: ["read", "create"],
    },
  },
  {
    name: "Financeiro",
    permissions: {
      contacts: ["read", "create", "update", "export"],
      products: ["read", "read_cost"],
      warehouses: ["read"],
      stock: ["read"],
      price_lists: ["read"],
      payment_terms: ["read", "create", "update"],
      sellers: ["read"],
      statuses: ["read"],
      quotes: ["read"],
      sales_orders: ["read"],
      tax_operations: ["read"],
      invoices: ["read", "create", "update"],
      inbound_invoices: ["read", "create", "update"],
      purchase_orders: ["read"],
      production_orders: ["read"],
      grouped_billing: ["read", "create", "update"],
      contracts: ["read", "create", "update"],
      service_orders: ["read"],
      receivables: ["read", "create", "update", "settle_discount"],
      payables: ["read", "create", "update", "settle_discount"],
      financial_accounts: ["read", "create", "update", "delete"],
      financial_categories: ["read", "create", "update", "delete"],
      payment_methods: ["read", "create", "update", "delete"],
      payment_integrations: ["read", "update"],
      cnab: ["read", "create", "update"],
      gnre: ["read", "create", "update"],
      pos: ["read", "create", "update"],
      logistics: ["read"],
      custom_reports: ["read", "create", "update", "export"],
      label_templates: ["read"],
      accounting: ["read", "create", "update"],
      ai_agents: ["read"],
      commissions: ["create", "pay"],
      dashboard: ["read"],
      goals: ["read"],
      copilot: ["read"],
      attachments: ["read", "create"],
      jobs: ["read", "create"],
    },
  },
  {
    name: "Estoque",
    permissions: {
      contacts: ["read"],
      products: ["read", "create", "update", "export", "read_cost"],
      warehouses: ["read", "create", "update"],
      stock: ["read", "create", "update"],
      price_lists: ["read"],
      payment_terms: ["read"],
      sellers: ["read"],
      statuses: ["read"],
      sales_orders: ["read"],
      service_orders: ["read"],
      invoices: ["read"],
      inbound_invoices: ["read", "create", "update"],
      purchase_orders: ["read", "create", "update"],
      production_orders: ["read", "create", "update"],
      checkout: ["read", "create"],
      copilot: ["read"],
      marketplaces: ["read", "update"],
      logistics: ["read", "create", "update"],
      custom_reports: ["read", "create", "update", "export"],
      label_templates: ["read", "create", "update"],
      ai_agents: ["read"],
      attachments: ["read"],
      jobs: ["read", "create"],
    },
  },
  // Contador: somente leitura (RF-CTB-02), sem auditoria (diffs com PII e IP) e sem usuários (SEG18).
  // Custo de produto é dado contábil: o Contador vê (products:read_cost), o Vendedor não.
  {
    name: "Contador",
    permissions: {
      ...readOnly([
        "contacts",
        "products",
        "warehouses",
        "stock",
        "price_lists",
        "payment_terms",
        "sellers",
        "statuses",
        "quotes",
        "sales_orders",
        "receivables",
        "payables",
        "financial_accounts",
        "financial_categories",
        "payment_methods",
        "payment_integrations",
        "dashboard",
        "goals",
        "copilot",
        "marketplaces",
        "tax_operations",
        "invoices",
        "inbound_invoices",
        "purchase_orders",
        "production_orders",
        "grouped_billing",
        "contracts",
        "service_orders",
        "cnab",
        "gnre",
        "pos",
        "logistics",
        "custom_reports",
        "label_templates",
        "accounting",
        "custom_fields",
        "attachments",
        "jobs",
        "deletions",
        "companies",
      ]),
      products: ["read", "read_cost"],
    },
  },
];
